import {StyleSheet} from 'react-native';

const StoreCheckListStyle = StyleSheet.create({
  mainContainer: {
    justifyContent: 'flex-end',
    maxWidth: '35%',
  },
  separator: {marginRight: 10},
});

const StoreCheckBoxStyle = StyleSheet.create({
  mainContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageBoxList: {
    width: 34,
    height: 34,
  },
  container: {
    justifyContent: 'space-evenly',
    flexDirection: 'row',
    width: 45,
    paddingVertical: 4,
    borderRadius: 15,
    bottom: 10,
    alignItems: 'center',
  },
  checkBoxStyle: {
    borderWidth: 0.5,
    width: 14,
    height: 14,
    borderRadius: 2,
    flexShrink: 0,
    padding: 1,
  },
  checkBox: {
    alignSelf: 'center',
  },
});

export {StoreCheckListStyle, StoreCheckBoxStyle};
